import React, { useEffect } from "react";
import ContentHeadCapsul from "./ContentHeadCapsul";
import ContentTitle from "./ContentTitle";
import ContentPara from "./ContentPara";
import PauseOnHover from "../components/PauseOnHover";
import Quote from "../assets/images/webp/quote-img.webp";
import { customerReview } from "../data";
import { Container } from "react-bootstrap";

const Testimonials = () => {
  // const [maxHeight, setHeight] = useState(0);

  const adjustHeights = () => {
    const cards = document.querySelectorAll(".review-card");
    let maxHeight = 0;

    cards.forEach((card) => {
      card.style.height = "auto"; // reset
      maxHeight = Math.max(maxHeight, card.offsetHeight);
    });

    cards.forEach((card) => (card.style.height = maxHeight + "px"));
  };

  // adjustHeights();

  useEffect(() => {
    adjustHeights();
    window.addEventListener("resize", adjustHeights);

    return () => window.removeEventListener("resize", adjustHeights);
  }, [customerReview]);

  return (
    <section className="section">
      <Container>
        <div className="max-w-500 mx-auto text-center mb-5">
          <ContentHeadCapsul>Testimonials</ContentHeadCapsul>
          <ContentTitle>
            What Our Clients{" "}
            <span className="text-deep-moss-green">Say About Us</span>
          </ContentTitle>
          <ContentPara>
            Trusted by thousands — with 90% satisfaction across 750+ reviews and
            over 6,000 completed projects.
          </ContentPara>
        </div>
        <PauseOnHover
          dots={true}
          infinite={true}
          slidesToShow={4}
          slidesToScroll={4}
          autoplay={true}
          autoplaySpeed={2000}
          arrows={false}
        >
          {customerReview.map((review) => (
            <div key={review.id} className="col-sm12">
              <article className="p-3 rounded-4 mx-2 border-light-silver bg-cultured d-flex flex-column review-card">
                <img
                  src={Quote}
                  width={"32px"}
                  height={"32px"}
                  alt="Customer testimonial quote icon"
                  className="mb-3"
                />
                <p className="">{review.customerReview}</p>
                <div className="d-flex align-items-center mt-auto">
                  <img
                    src={review.customerImage}
                    width={"60px"}
                    height={"60px"}
                    loading="lazy"
                    alt="Customer review profile image"
                  />
                  <div className="ms-2">
                    <h4 className="h5 text-eerie-black fw-600">
                      {review.customerName}
                    </h4>
                    <p className="m-0 fs-14 text-deep-moss-green">
                      {review.customerDesignation}
                    </p>
                  </div>
                </div>
              </article>
            </div>
          ))}
        </PauseOnHover>
      </Container>
    </section>
  );
};

export default Testimonials;
